import React, { useState, useEffect } from "react";
import api from "../../api";
import TagManager from 'react-gtm-module';

const FloatingDownloadBanner = () => {
  const [showEbookModal, setShowEbookModal] = useState(false);
  const [ebookForm, setEbookForm] = useState({
    name: "",
    email: "",
    company: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  // 문의폼 섹션이 보이면 배너 숨기기
  useEffect(() => {
    const signupSection = document.querySelector("#signup");
    
    if (!signupSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsFormVisible(entry.isIntersecting);
        });
      },
      {
        threshold: 0.1, // 10% 이상 보이면 감지
        rootMargin: "0px 0px -100px 0px", // 하단 100px 여유
      }
    );

    observer.observe(signupSection);

    return () => {
      observer.disconnect();
    };
  }, []);

  // 서비스 소개서 다운로드 (즉시)
  const handleDownloadBrochure = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "brochure_download",
        content_name: "service_introduction",
        content_type: "pdf",
        download_location: "floating_banner",
        page_type: "free_trial_landing",
      },
    });

    window.open(
      "https://cdn.switchuplab.com/PDF/switchup-service-introduction.pdf",
      "_blank"
    );
  };

  // 전자책 모달 열기
  const handleOpenEbookModal = () => {
    setShowEbookModal(true);
  };

  // 전자책 모달 닫기
  const handleCloseEbookModal = () => {
    setShowEbookModal(false);
    setEbookForm({ name: "", email: "", company: "" });
    setSubmitMessage(null);
  };

  // 폼 입력 핸들러
  const handleEbookFormChange = (e) => {
    const { name, value } = e.target;
    setEbookForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 전자책 신청 핸들러
  const handleEbookSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!ebookForm.name.trim()) {
      setSubmitMessage({ type: "error", text: "이름을 입력해주세요." });
      return;
    }
    if (!ebookForm.email.trim()) {
      setSubmitMessage({ type: "error", text: "이메일을 입력해주세요." });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ebookForm.email)) {
      setSubmitMessage({
        type: "error",
        text: "유효한 이메일 주소를 입력해주세요.",
      });
      return;
    }
    if (!ebookForm.company.trim()) {
      setSubmitMessage({ type: "error", text: "회사명을 입력해주세요." });
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      // API 호출 (프로젝트의 api 객체를 import해서 사용하세요)
      // import api from '../path/to/api';

      const response = await api.post("marketing/ebook-subscribe/", {
        email: ebookForm.email,
        name: ebookForm.name,
        company_name: ebookForm.company,
      });

      // 성공 처리
      setSubmitMessage({
        type: "success",
        text: "전자책이 이메일로 발송되었습니다! 📧",
      });

      // 3초 후 모달 닫기
      setTimeout(() => {
        handleCloseEbookModal();
      }, 3000);
    } catch (error) {
      console.error("Ebook subscription error:", error);
      setSubmitMessage({
        type: "error",
        text: "전송 중 오류가 발생했습니다. 다시 시도해주세요.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // 문의폼이 보일 때만 배너 표시
  if (!isFormVisible) return null;

  return (
    <>
      {/* 하단 우측 배너 */}
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 animate-slide-up">
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={handleDownloadBrochure}
            className="px-4 py-2 sm:px-6 sm:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-bold text-xs sm:text-sm lg:text-base shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            📄 서비스 소개서 받기
          </button>
            {/* 전자책 버튼 - 주석처리 */}
            {/* <button
              onClick={handleOpenEbookModal}
              className="px-5 py-2 bg-yellow-400 text-gray-900 rounded-lg hover:bg-yellow-500 transition-all font-bold text-sm shadow-lg hover:shadow-xl relative"
            >
              📚 전자책 받기
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
                인기
              </span>
            </button> */}
        </div>
      </div>

      {/* 전자책 모달 - 주석처리 */}
      {/* {showEbookModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 animate-fade-in">
          <div className="bg-white rounded-2xl max-w-md w-full p-6 sm:p-8 shadow-2xl animate-scale-in">
            {/* 헤더 
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                <span className="text-3xl">📚</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                A/B 테스트 전자책
              </h3>
              <p className="text-sm text-gray-600">
                실전 가이드를 이메일로 받아보세요
              </p>
            </div>

            {/* 폼 
            <form onSubmit={handleEbookSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="ebook-name"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  이름 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="ebook-name"
                  name="name"
                  value={ebookForm.name}
                  onChange={handleEbookFormChange}
                  placeholder="홍길동"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="ebook-email"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  이메일 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="ebook-email"
                  name="email"
                  value={ebookForm.email}
                  onChange={handleEbookFormChange}
                  placeholder="example@company.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="ebook-company"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  회사명 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="ebook-company"
                  name="company"
                  value={ebookForm.company}
                  onChange={handleEbookFormChange}
                  placeholder="회사명을 입력해주세요"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
                  required
                />
              </div>

              {/* 메시지 
              {submitMessage && (
                <div
                  className={`p-3 rounded-lg text-sm ${
                    submitMessage.type === "success"
                      ? "bg-green-50 text-green-800"
                      : "bg-red-50 text-red-800"
                  }`}
                >
                  {submitMessage.text}
                </div>
              )}

              {/* 버튼 
              <div className="flex gap-3 pt-2">
                <button
                  type="button"
                  onClick={handleCloseEbookModal}
                  className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  취소
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "전송 중..." : "전자책 받기"}
                </button>
              </div>
            </form>

            <p className="text-xs text-gray-500 text-center mt-4">
              입력하신 정보는 전자책 발송 용도로만 사용됩니다
            </p>
          </div>
        </div>
      )}
      */}

      {/* 애니메이션 CSS */}
      <style>{`
        @keyframes slide-up {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scale-in {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }

        .animate-fade-in {
          animation: fade-in 0.2s ease-out;
        }

        .animate-scale-in {
          animation: scale-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default FloatingDownloadBanner;